<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chtitle">Contents</h1>
<p class="toc"><a href="#/B1_Chapter_1">Chapter One</a></p>
<p class="toc"><a href="#/B1_Chapter_2">Chapter Two</a></p>
<p class="toc"><span href="#/B1_Chapter_3" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc"><span href="#/B1_Chapter_4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc"><span href="#/B1_Chapter_5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc"><span href="#/B1_Chapter_6" title="Link target outside of Sample">Chapter Six</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// B1_Contents.vue?55b29c12